<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
    <form [formGroup]="companyForm" (ngSubmit)="onSave()">
        <h1 class="heading">
            {{companyId ? 'Edit' : 'Add'}}
        </h1>
        <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 sm:grid-cols-2">
            <div class="space-y-1">
                <label class="subheading">
                    Name
                </label>
                <div>
                    <div>
                        <input formControlName="displayName" type="text" />
                    </div>
                    <div *ngIf="submitted && form.displayName.errors">
                        <p *ngIf="form.displayName.errors.required" class="pt-1 text-red-600 text-xs">
                            Company Name is required
                        </p>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Email
                </label>
                <div>
                    <div>
                        <input formControlName="email" type="email" />
                    </div>
                    <div *ngIf="submitted && form.email.errors">
                        <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                            Email is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    State Code
                </label>
                <div>
                    <div>
                        <select formControlName="stateCode">
                            <option value=""> Select the State Code</option>
                            <option value="test">Test</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.stateCode.errors">
                        <p *ngIf="form.stateCode.errors.required" class="pt-1 text-red-600 text-xs">
                            State Code is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Address
                </label>
                <div>
                    <div formGroupName="address">
                        <input formControlName="name" type="text" placeholder="Enter Address" />
                    </div>
                    <div *ngIf="submitted && (address.get('name')?.errors || address.get('coords')?.errors)">
                        <p *ngIf="address.get('name')?.errors?.required || address.get('coords')?.errors?.required" class="pt-1 text-red-600 text-xs">
                          Address is required
                        </p>
                      </div>
                </div>
            </div>

            <div class="space-y-1">
                <label class="subheading">
                    Timezone
                </label>
                <div>
                    <div>
                        <input formControlName="timezone" type="date" />
                    </div>
                    <div *ngIf="submitted && form.timezone.errors">
                        <p *ngIf="form.timezone.errors.required" class="pt-1 text-red-600 text-xs">
                            Timezone is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Date Format
                </label>
                <div>
                    <div>
                        <select id="account-status" formControlName="dateFormat">
                            <option value=""> Select Date Format</option>
                            <option value="MM/DD/YYYY">MM/DD/YYYY</option>
                            <option value="DD/MM/YYYY">DD/MM/YYYY</option>
                        </select>
                    </div>

                    <div *ngIf="submitted && form.dateFormat.errors">
                        <p *ngIf="form.dateFormat.errors.required" class="pt-1 text-red-600 text-xs">
                            Date Format is required
                        </p>
                    </div>


                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Time Format
                </label>
                <div>
                    <div>
                        <select formControlName="timeFormat">
                            <option value="">
                                Select the Time Format
                            </option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.timeFormat.errors">
                        <p *ngIf="form.timeFormat.errors.required" class="pt-1 text-red-600 text-xs">
                            Time Format is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Company Contact Number
                </label>
                <div>
                    <div>
                        <input formControlName="contactNumber" type="text" />
                    </div>
                    <div *ngIf="submitted && form.contactNumber.errors">
                        <p *ngIf="form.contactNumber.errors.required" class="pt-1 text-red-600 text-xs">
                            Company Contact Number is required
                        </p>
                        <p *ngIf="submitted && (form.contactNumber.errors?.minlength || form.contactNumber.errors?.maxlength)" class="pt-1 text-red-600 text-xs">
                            Minimum 10 digits are required and maximum 11 digits are allowed
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Company Logo
                </label>
                <div>
                    <div class="col-span-full">
                        <div class="flex items-center gap-x-3">
                            <svg class="size-20 text-zinc-950/40 dark:text-white/40" viewBox="0 0 24 24"
                                fill="currentColor" aria-hidden="true" data-slot="icon">
                                <path fill-rule="evenodd"
                                    d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"
                                    clip-rule="evenodd" />
                            </svg>
                            <button type="button" class="btn-outline btn-outline-secondary">Change</button>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <h2 class="heading">
            Legal Information
        </h2>
        <p class="text-sm-light">
            Please provide accurate and authentic information.
        </p>
        <section class="mt-4 grid gap-4 sm:grid-cols-2">
            <div class="space-y-1">
                <label class="subheading">
                    Extension/Dispather Number
                </label>
                <div>
                    <div>
                        <input formControlName="extensionDispatcherNumber" type="tel" />
                    </div>
                    <div *ngIf="submitted && form.extensionDispatcherNumber.errors">
                        <p *ngIf="form.extensionDispatcherNumber.errors.required" class="pt-1 text-red-600 text-xs">
                            Extension Dispatcher Number is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Company Fax Number
                </label>
                <div>
                    <div>
                        <input formControlName="companyFaxNumber" type="tel" />
                    </div>
                    <div *ngIf="submitted && form.companyFaxNumber.errors">
                        <p *ngIf="form.companyFaxNumber.errors.required" class="pt-1 text-red-600 text-xs">
                            Company Fax Number is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Password
                </label>
                <div>
                    <div>
                        <input formControlName="password" type="password" />
                    </div>
                    <div *ngIf="submitted && form.password.errors">
                        <p *ngIf="form.password.errors.required" class="pt-1 text-red-600 text-xs">
                            password is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Confirm Password
                </label>
                <div>
                    <div>
                        <input formControlName="confirmPassword" type="password" />
                    </div>
                    <div *ngIf="submitted && form.confirmPassword.errors">
                        <p *ngIf="form.confirmPassword.errors.required" class="pt-1 text-red-600 text-xs">
                            Confirm Password is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Status
                </label>
                <div>
                    <div>
                        <select formControlName="isActive">
                            <option [ngValue]="null">Select Status</option>
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Inactive</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.isActive.errors">
                        <p *ngIf="form.isActive.errors.required" class="pt-1 text-red-600 text-xs">
                            Status is required
                        </p>
                    </div>


                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    NPI/AHCCCS PID <span class="text-xs-light font-normal">
                        (Mandatory for medicaid and CMS 1500 Forms)
                    </span>
                </label>
                <div>
                    <div>
                        <input formControlName="npiAhcccsPid" type="text" />
                    </div>
                    <div *ngIf="submitted && form.npiAhcccsPid.errors">
                        <p *ngIf="form.npiAhcccsPid.errors.required" class="pt-1 text-red-600 text-xs">
                            NPI/Ahcccs/Pid is required
                        </p>
                    </div>


                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Tax ID <span class="text-xs-light font-normal">
                        (Mandatory CMS 1500 Forms)
                    </span>
                </label>
                <div>
                    <div>
                        <input formControlName="taxId" type="text" />
                    </div>
                    <div *ngIf="submitted && form.taxId.errors">
                        <p *ngIf="form.taxId.errors.required" class="pt-1 text-red-600 text-xs">
                            Tax ID is required
                        </p>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Associate Companies
                </label>
                <div>
                    <div>
                        <select formControlName="associateCompanies">
                            <option value="">
                                Select the Associate Companies
                            </option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.associateCompanies.errors">
                        <p *ngIf="form.associateCompanies.errors.required" class="pt-1 text-red-600 text-xs">
                            Associate Companies is required
                        </p>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Onboarding Status
                </label>
                <div>
                    <div>
                        <select formControlName="onboardingStatus">
                            <option value="">Select Onboarding status
                            <option>
                            <option value="inprogress">In Progress
                            <option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.onboardingStatus.errors">
                        <p *ngIf="form.onboardingStatus.errors.required" class="pt-1 text-red-600 text-xs">
                            Onboarding Status is required
                        </p>
                    </div>
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Trial End
                </label>
                <div>
                    <div>
                        <input formControlName="trialEnd" type="date" />
                    </div>
                    <div *ngIf="submitted && form.trialEnd.errors">
                        <p *ngIf="form.trialEnd.errors.required" class="pt-1 text-red-600 text-xs">
                            Trial End is required
                        </p>
                    </div>
                </div>
            </div>
            <div formGroupName="focalPerson" class="col-span-full">
                <div class="grid gap-4 sm:grid-cols-2">
                    <div class="space-y-1">
                        <label class="subheading">
                            Focal Person Name
                            <span class="text-xs-light font-normal">
                                (Mandatory for medicaid Auth Form)
                            </span>
                        </label>
                        <div>
                            <div>
                                <div>
                                    <input formControlName="displayName" type="text" />
                                </div>
                                <div *ngIf="submitted && focalPerson.get('displayName')?.errors">
                                    <p *ngIf="focalPerson.get('displayName')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                      Address is required
                                    </p>
                                  </div>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Focal Person Contact <span class="text-xs-light font-normal">
                                (Mandatory for medicaid Auth Form)
                            </span>
                        </label>
                        <div>
                            <div>
                                <div>
                                    <input formControlName="contactNumber" type="text" />
                                </div>
                            </div>
                            <div *ngIf="submitted && focalPerson.get('contactNumber')?.errors">
                                <p *ngIf="focalPerson.get('contactNumber')?.errors?.required" class="pt-1 text-red-600 text-xs">
                                    Focal Person Contact is required
                                </p>
                                <p *ngIf="submitted && (focalPerson.get('contactNumber')?.errors?.minlength || focalPerson.get('contactNumber')?.errors?.maxlength)" class="pt-1 text-red-600 text-xs">
                                    Minimum 10 digits are required and maximum 11 digits are allowed
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Review URL
                </label>
                <div>
                    <div>
                        <input formControlName="reviewUrl" type="url" />
                    </div>
                    <div *ngIf="submitted && form.reviewUrl.errors">
                        <p *ngIf="form.reviewUrl.errors.required" class="pt-1 text-red-600 text-xs">
                            Review URL is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Time in At
                </label>
                <div>
                    <div>
                        <select formControlName="timeInAt">
                            <option value="">Select the Time in At</option>
                        </select>
                    </div>
                    <div *ngIf="submitted && form.timeInAt.errors">
                        <p *ngIf="form.timeInAt.errors.required" class="pt-1 text-red-600 text-xs">
                            Time in At required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Cushion B/W CA Break Time <span class="text-xs-light font-normal">(In minutes)</span>
                </label>
                <div>
                    <div>
                        <input formControlName="cushionBetweenCABreakTime" type="text" />
                    </div>
                    <div *ngIf="submitted && form.cushionBetweenCABreakTime.errors">
                        <p *ngIf="form.cushionBetweenCABreakTime.errors.required" class="pt-1 text-red-600 text-xs">
                            Cushion Between CA Break Time is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    CA Break Time Caution <span class="text-xs-light font-normal">(In minutes)</span>
                </label>
                <div>
                    <div>
                        <input formControlName="caBreakTimeCaution" type="text" />
                    </div>
                    <div *ngIf="submitted && form.caBreakTimeCaution.errors">
                        <p *ngIf="form.caBreakTimeCaution.errors.required" class="pt-1 text-red-600 text-xs">
                            CA Break Time Caution is required
                        </p>
                    </div>

                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Company Notes
                </label>
                <div>
                    <div>
                        <textarea formControlName="companyNotes" class="h-16"></textarea>
                    </div>
                    <div *ngIf="submitted && form.companyNotes.errors">
                        <p *ngIf="form.companyNotes.errors.required" class="pt-1 text-red-600 text-xs">
                            Company Notes is required
                        </p>
                    </div>

                </div>
            </div>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <h2 class="heading">
            Permissions
        </h2>
        <p class="text-sm-light">
            Provide the permissions you want to grant to the company.
        </p>
        <section
            class="mt-4 flex flex-wrap gap-4 p-2 border-2 border-zinc-950/10 dark:border-white/5 rounded-lg border-dashed">
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="allowTimesheet" type="checkbox" />
                </div>
                <label class="subheading">
                    Allow Timesheet
                </label>
            </div>
            <!-- <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="allowCamera" type="checkbox" />
                </div>
                <label class="subheading">
                    Allow Camera
                </label>
            </div> -->
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="allowAttendee" type="checkbox" />
                </div>
                <label class="subheading">
                    Allow Attendee
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="tripAssistance" type="checkbox" />
                </div>
                <label class="subheading">
                    Trip Assistance
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="allowNearBy" type="checkbox" />
                </div>
                <label class="subheading">
                    Allow Nearby
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="allowSms" type="checkbox" />
                </div>
                <label class="subheading">
                    Allow SMS
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="alcReminder" type="checkbox" />
                </div>
                <label class="subheading">
                    ALC Reminder
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="forcedAcceptTrips" type="checkbox" />
                </div>
                <label class="subheading">
                    Forced Accept Trips
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="" type="checkbox" />
                </div>
                <label class="subheading">
                    Forced Accept Trips
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="iaal" type="checkbox" />
                </div>
                <label class="subheading">
                    LAAL
                </label>
            </div>
            <!-- <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="medical" type="checkbox" />
                </div>
                <label class="subheading">
                    Medical
                </label>
            </div> -->
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="calculateLocalMiles" type="checkbox" />
                </div>
                <label class="subheading">
                    Calculate Local Miles
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="showRoute" type="checkbox" />
                </div>
                <label class="subheading">
                    Show Routes
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="deadMiles" type="checkbox" />
                </div>
                <label class="subheading">
                    Dead Miles
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="skipSignature" type="checkbox" />
                </div>
                <label class="subheading">
                    Skip Signature
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="listView" type="checkbox" />
                </div>
                <label class="subheading">
                    List View
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="odometerRequired" type="checkbox" />
                </div>
                <label class="subheading">
                    Odometer Required
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="ctcMarketplace" type="checkbox" />
                </div>
                <label class="subheading">
                    CTC Marketplace
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="cms1500" type="checkbox" />
                </div>
                <label class="subheading">
                    CMS 1500
                </label>
            </div>
            <!-- <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="corporateOdometerRequired" type="checkbox" />
                </div>
                <label class="subheading">
                    Corporate Odometer Required
                </label>
            </div> -->
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="caTimesheet" type="checkbox" />
                </div>
                <label class="subheading">
                    CA Timesheet
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="associateImage" type="checkbox" />
                </div>
                <label class="subheading">
                    Associate Image
                </label>
            </div>
            <div class="flex items-center gap-2">
                <div class="-mt-1">
                    <input formControlName="allowUber" type="checkbox" />
                </div>
                <label class="subheading">
                    Allow Uber
                </label>
            </div>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="flex justify-end gap-4">
            <!-- <button class="btn-outline btn-outline-secondary">
                Reset
            </button> -->
            <button class="btn btn-secondary">
                {{companyId ? 'Update' : 'Create'}}
            </button>
        </section>
    </form>
</div>